/**
 * Single source of truth for application URL paths.
 * Replaces hard-coded /admin/klienten/${id}-style templates that
 * proliferated across the codebase (Audit Code-Hygiene 24).
 *
 * Coach routes have NO /admin prefix — coach.teamity.io is already
 * the Coach surface by virtue of its subdomain.
 */

export const routes = {
  // app.teamity.io
  app: {
    hub: () => '/',
    userSettings: () => '/einstellungen',
  },
  innerTeam: {
    home: () => '/inner-team',
    discovery: () => '/inner-team/entdecken',
    discoveryChat: (id: string) => `/inner-team/entdecken/${id}`,
    teamDashboard: () => '/inner-team/team',
    memberDetail: (id: string) => `/inner-team/team/${id}`,
    memberChat: (id: string) => `/inner-team/konsultation/${id}`,
    teamChat: (id: string) => `/inner-team/team-konsultation/${id}`,
  },
  // coach.teamity.io
  coach: {
    dashboard: () => '/',
    welcome: () => '/welcome',
    settings: () => '/einstellungen',
    apps: () => '/apps',
    client: (id: string) => `/klienten/${id}`,
    session: (clientId: string, sessionId: string) =>
      `/klienten/${clientId}/sessions/${sessionId}`,
    report: (clientId: string, reportId: string) =>
      `/klienten/${clientId}/reports/${reportId}`,
    operator: {
      dashboard: () => '/plattform',
      vouchers: () => '/plattform/vouchers',
      voucherCreate: () => '/plattform/vouchers/new',
      voucher: (code: string) => `/plattform/vouchers/${code}`,
      users: () => '/plattform/nutzer',
      user: (id: string) => `/plattform/nutzer/${id}`,
      analytics: () => '/plattform/analytics',
      announcements: () => '/plattform/announcements',
      coaches: () => '/plattform/coaches',
    },
  },
};
